import { graphql } from 'react-relay';

export const performanceOverviewCurrencySelectionFragment = graphql`
    fragment PerformanceOverviewCurrencySelection_currencySelection on SelectBox {
        ...Selectbox_selectBox
    }
`;
